__turbopack_context__.v({
  "amethyst": "text-colors-module-scss-module__QlUAxW__amethyst",
  "black": "text-colors-module-scss-module__QlUAxW__black",
  "default": "text-colors-module-scss-module__QlUAxW__default",
  "dim": "text-colors-module-scss-module__QlUAxW__dim",
  "future-fuscia": "text-colors-module-scss-module__QlUAxW__future-fuscia",
  "negative": "text-colors-module-scss-module__QlUAxW__negative",
  "primary": "text-colors-module-scss-module__QlUAxW__primary",
  "springtime": "text-colors-module-scss-module__QlUAxW__springtime",
  "white": "text-colors-module-scss-module__QlUAxW__white",
});
